import type { Styles } from '@adornis/ass/style.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { DigitaleHeldenFont } from '../theme/fonts';
import './component-badge.js';

@customElement('component-badge-live')
export class ComponentBadgeLive extends ChemistryLitElement {
  override render() {
    return html`
      <component-badge
        text="LIVE"
        border-radius="14px"
        background=${this.colors.tone.light_cyan!}
        color=${this.colors.tone.dark_cyan!}
        .additionalTextStyle=${{ fontFamily: DigitaleHeldenFont.BLACK }}
      ></component-badge>
    `;
  }
  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {},
      },
    ] as Styles[];
  }
}
